import { DESKTOP_MIN_WIDTH } from '@/components/blocks/PLPProductCard/constants';
import {
	plpWishListContainer,
	plpWishListIcon,
	plpWishListLineDivider,
} from '@/components/blocks/PLPProductCard/styles/productCardWishlist';
import { MoveWishListItemMenu } from '@/components/content/HdmWishlistDetail/parts/MoveWishListItemMenu';
import DynamicIcon from '@/components/icons/DynamicIcon';
import { useUser } from '@/data/User';
import { ProductType } from '@/data/types/Product';
import { Box, IconButton, SxProps, Theme, useMediaQuery, useTheme } from '@mui/material';
import { MouseEvent, useState } from 'react';
import { MATERIAL_SYMBOL_ICONS } from 'shared/custom/constants/commonConstants';

export const ProductCardWishlist = ({
	product,
	isProductInAnyWishlist = false,
	sx,
	bundleId,
}: {
	product: ProductType;
	isProductInAnyWishlist?: boolean;
	sx?: SxProps<Theme>;
	bundleId?: string;
}) => {
	const theme = useTheme();
	const isMobile = useMediaQuery(theme.breakpoints.down(DESKTOP_MIN_WIDTH - 1));
	const { user } = useUser();
	const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
	const [hoverFavorite, setHoverFavorite] = useState(false);
	const isMenuOpen = Boolean(anchorEl);

	if (!user?.isLoggedIn) return null;

	const openMenu = (event: MouseEvent<HTMLElement>) => {
		event.preventDefault();
		event.stopPropagation();
		setAnchorEl(event.currentTarget);
	};

	const showFavoriteIconFilled = isProductInAnyWishlist || hoverFavorite || isMenuOpen;

	return (
		<>
			<Box sx={sx ? sx : plpWishListContainer(isMobile)}>
				<IconButton
					aria-label="Agregar a lista de favoritos"
					aria-pressed={isProductInAnyWishlist}
					disableRipple
					disableFocusRipple
					disableTouchRipple
					onMouseEnter={() => setHoverFavorite(true)}
					onMouseLeave={() => setHoverFavorite(false)}
					sx={plpWishListIcon}
					onClick={openMenu}
				>
					<DynamicIcon
						size={20}
						name={MATERIAL_SYMBOL_ICONS.favorite}
						color={theme.palette.primary.main}
						variant={showFavoriteIconFilled ? 'filled' : 'rounded'}
					/>
				</IconButton>
				<Box className="hover-line" sx={plpWishListLineDivider} />
			</Box>
			<MoveWishListItemMenu
				anchorEl={anchorEl}
				setAnchorEl={setAnchorEl}
				productAction={product}
				isPLP
				bundleId={bundleId}
			/>
		</>
	);
};
